import { gql } from '@apollo/client';

export const deleteNoteEntry = gql`
  mutation deleteNoteEntry($id: String) {
    deleteNoteEntry(id: $id)
  }
`;
